import React from "react";

export default function CalcErrorOverlay({
  visible,
  message, // kept for compatibility, but no longer shown as the title
  onBackToLayout,
  supportNumber = "01444 247020",
}) {
  if (!visible) return null;

  const telHref = `tel:${supportNumber.replace(/\s+/g, "")}`;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        // Dim + blur the background behind the overlay
        backgroundColor: "rgba(0,0,0,0.35)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "auto",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#rgba(151,151,151,0.85)",
          border: "1px solid orange",
          padding: "28px 32px",
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          width: "min(720px, 90vw)",
          color: "#ffffff",
          textAlign: "center",
        }}
      >
        <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 10 }}>
          We couldn’t quite find a fit
        </div>

        <p style={{ margin: "6px 0 18px", fontSize:14, lineHeight: 1.2 }}>
          Based on the room plans you’ve entered, our calculator was unable to
          determine a standard mat layout. This can sometimes happen with larger
          rooms or those with more intricate shapes, you have not done anything
          incorrectly. Heating mats come in fixed sizes and can’t be cut or
          altered and for complex spaces, finding a perfect fit with standard
          mats can be tricky. Our team of experts is on hand to help design a
          custom solution for you. Please call our technical support team for a
          personalised recommendation.
        </p>

        <div
          style={{
            display: "flex",
            gap: 12,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            type="button"
            onClick={onBackToLayout}
            style={{
              cursor: "pointer",
              padding: "10px 20px",
              borderRadius: 30,
              border: "1px solid orange",
              background:
                  "linear-gradient(121.93deg, rgba(255,255,255,0.25) -4.53%, rgba(255,255,255,0.15) 77.31%)",
              color: "#ffffff",
            }}
          >
            Back to layout
          </button>

          <a href={telHref} style={{ textDecoration: "none" }}>
            <button
              type="button"
              style={{
                cursor: "pointer",
                padding: "10px 20px",
                borderRadius: 30,
                border: "1px solid orange",
                background:
                  "linear-gradient(121.93deg, rgba(255,255,255,0.25) -4.53%, rgba(255,255,255,0.15) 77.31%)",
                color: "#ffffff",
              }}
            >
              Call technical support
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
